export var UnitBaseType;
(function (UnitBaseType) {
    UnitBaseType[UnitBaseType["Infantry"] = 1] = "Infantry";
    UnitBaseType[UnitBaseType["Missile"] = 2] = "Missile";
    UnitBaseType[UnitBaseType["Mounted"] = 3] = "Mounted";
})(UnitBaseType || (UnitBaseType = {}));
